import api from "@/utils/api";

export const ecSendCode = async (email: string) => {
  return (await api.post("/ec/auth/send-code", { email })).data;
};

export const ecVerifyCode = async (email: string, code: string) => {
  return (await api.post("/ec/auth/verify-code", { email, code })).data;
};

export const ecSwitchAccount = async (accountId: string) => {
  return (await api.post("/ec/auth/switch-account", { accountId })).data;
};

export const ecGetProjects = async () => {
  return (await api.get("/ec/projects")).data;
};

export const ecGetProject = async (id: string) => {
  return (await api.get(`/ec/projects/${id}`)).data;
};

export const ecGetOrders = async () => {
  return (await api.get("/ec/orders")).data;
};

export const ecGetOrder = async (id: string) => {
  return (await api.get(`/ec/orders/${id}`)).data;
};

/**
 * Download the Swiftlane invoice PDF for an order. The invoice record is
 * created on the server on first download and reused thereafter. Returns the
 * raw Axios response so the caller can read the PDF blob.
 */
export const ecDownloadOrderInvoice = async (id: string) => {
  return api.get(`/ec/orders/${id}/invoice/pdf`, { responseType: "blob" });
};

/** List all proposals visible to this EC account (signed by at least the customer) */
export const ecGetDocuments = async () => {
  return (await api.get("/ec/documents")).data;
};

/** Get a single proposal document */
export const ecGetDocument = async (id: string) => {
  return (await api.get(`/ec/documents/${id}`)).data;
};

export const ecAddOrderPaymentMethod = async (orderId: string, paymentMethodId?: string) => {
  return (await api.post(`/ec/orders/${orderId}/add-payment`, { paymentMethodId })).data;
};

export const ecChargeOrder = async (orderId: string, paymentMethodId?: string) => {
  return (await api.post(`/ec/orders/${orderId}/charge`, { paymentMethodId })).data;
};

// ── Payment methods ──────────────────────────────────────────────────────────

export const ecGetPaymentMethods = async () => {
  return (await api.get("/ec/payment-methods")).data;
};

/** Create a Stripe SetupIntent for credit card capture */
export const ecCreateSetupIntent = async (): Promise<{ clientSecret: string }> => {
  return (await api.post("/ec/payment-methods/card/setup-intent")).data;
};

/** Save a credit card after Stripe SetupIntent confirmation */
export const ecSaveCreditCard = async (data: { paymentMethodId: string }) => {
  return (await api.post("/ec/payment-methods/card/save", data)).data.data;
};

/** Create a Stripe Financial Connections session for ACH bank account */
export const ecCreateBankAccountConnectSession = async (): Promise<{ clientSecret: string }> => {
  return (await api.post("/ec/payment-methods/bank-account/connect")).data;
};

/** Save a bank account from a Financial Connections session */
export const ecSaveBankAccount = async (data: { accountId: string }) => {
  return (await api.post("/ec/payment-methods/bank-account/save", data)).data.data;
};

/** Record ACH payment method consent */
export const ecRecordPaymentMethodConsent = async (data: {
  consented: boolean;
  consentText: string;
}): Promise<void> => {
  return (await api.post("/ec/payment-methods/consent", data)).data;
};

/** @deprecated Use ecCreateSetupIntent + ecSaveCreditCard instead */
export const ecSavePaymentMethod = async (paymentMethodId?: string) => {
  return (await api.post("/ec/payment-methods", { paymentMethodId })).data;
};

export const ecDeletePaymentMethod = async (id: string) => {
  return (await api.delete(`/ec/payment-methods/${id}`)).data;
};
